<template>
  <div class="flex gap-0.5 text-black">
    <div v-for="(star, idx) in stars" :key="idx" class="shrink-0">
      <EmptyStarIcon v-if="star === 'empty'" class="size-3" />
      <StarIcon v-if="star === 'full'" class="size-3" />
      <HalfStarIcon v-if="star === 'half'" class="size-3" />
    </div>
  </div>
</template>

<script>
import EmptyStarIcon from '~/components/icons/EmptyStarIcon'
import StarIcon from '~/components/icons/StarIcon'
import HalfStarIcon from '~/components/icons/HalfStarIcon'

export default {
  components: { HalfStarIcon, StarIcon, EmptyStarIcon },

  props: {
    stars: { type: Array, required: true },
  },
}
</script>
